import {useTranslate} from 'ra-core';
import React from 'react';

export const Commodity = {
	SALMON: "salmon",
	SALMON_PROD: "salmon_prod",
	SALMON_MIX: "salmon_mix",
	TROUTH: "trouth",
	WHITEFISH: "whitefish",
	BACALAO: "bacalao",
	DRYFISH: "dryfish",
	SCRIMP: "scrimp",
	OTHER: "other",
};

export const CommodityChoices = Object.values(Commodity).map(item => ({id: item, name: item}));

export const useCommodityChoices = () => {
	const t = useTranslate();

	const choices = React.useMemo(() => Object.values(Commodity).map(x => ({id: x, name: t(`osfc.enums.commodity.${x}`)})), [t]);

	return choices;
};